import React, { useCallback } from "react";
import queryString from "query-string";
import { Form } from "@unform/web";
import { noop, get } from "lodash";

import { fontNormal } from "../../_static/Typography";
import Button from "../../_atom/Buttons/button";
import SelectableBox from "../../_organism/SelectableBox";
import CircularLoader from "../../_static/CircularLoader";
import buildColor from "../../_static/ColorPalette";
import InputV2 from "../../_molecule/InputV2";
import {
  Container,
  InputContainer,
  ApplyButton,
  CircularLoadingContainer,
  Title,
  ButtonContainer,
  PromosContainer,
  PromosList,
  PromoListItem
} from "./styled-components";

const RegistrationPromoCodeTemplate = ({
  formRef,
  firstTitle,
  secondTitle,
  buttonText,
  isButtonDisabled,
  handlePromoCodeOnBlur,
  handlePromoCodeChange,
  handleSubmit,
  showApplyButton,
  showInputLoading,
  onClickApplyButton,
  promoCodes,
  onInputFocus,
  selectedPromoCode,
  handlePromoCodeClick,
  registrationAllPromosWithTC,
  handleTCClick
}) => {
  const params = useCallback(() => {
    const paramsParsed = queryString.parse(location.search);
    return Object.keys(paramsParsed).reduce(
      (acc, key) => ({
        ...acc,
        [key.toLowerCase()]: paramsParsed[key]
      }),
      {}
    );
  }, [JSON.stringify(location.search)]);

  return (
    <Container>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <InputContainer>
          <InputV2
            name="promoCodeInput"
            label={firstTitle}
            qaLabel="promo-code-input"
            customHandleOnBlur={handlePromoCodeOnBlur}
            customHandleChange={handlePromoCodeChange}
            marginBottom={12}
            onFocus={onInputFocus}
          />
          {showInputLoading && (
            <CircularLoadingContainer>
              <CircularLoader
                size="small"
                backgroundColor={buildColor("blue_accent", "500")}
                borderColor={buildColor("blue_accent", "200")}
              />
            </CircularLoadingContainer>
          )}
          {showApplyButton && (
            <ApplyButton
              data-qa-label="promo-code-apply-button"
              onClick={onClickApplyButton}
            >
              Apply
            </ApplyButton>
          )}
        </InputContainer>
        {!!Object.keys(promoCodes).length && (
          <PromosContainer>
            <Title mb={12}>{secondTitle}</Title>
            <PromosList>
              {Object.entries(promoCodes).map((promoCodesEntry, index) => {
                const promoCodeKey = promoCodesEntry[0];
                const promoCode = promoCodesEntry[1];
                return (
                  <PromoListItem
                    key={`promo-code-${index.toString()}`}
                    data-qa-label={`promo-code-container-${promoCodeKey}`}
                  >
                    <SelectableBox
                      id={`checkbox-promo-id-${promoCodeKey}`}
                      qaLabel="promo-code-checkbox-"
                      name={promoCodeKey}
                      title={
                        promoCodeKey === "raf"
                          ? params().rcode.toUpperCase()
                          : promoCodeKey
                      }
                      description={promoCode.name}
                      isChecked={selectedPromoCode === promoCodeKey}
                      onClick={() => handlePromoCodeClick(promoCodeKey)}
                      buttonText={
                        get(promoCode, "TCLink", "") &&
                        registrationAllPromosWithTC
                          ? "Terms & Conditions"
                          : ""
                      }
                      buttonTextOnClick={(event) => {
                        event.preventDefault();
                        handleTCClick(get(promoCode, "TCLink", ""));
                      }}
                    />
                  </PromoListItem>
                );
              })}
            </PromosList>
          </PromosContainer>
        )}
        <ButtonContainer>
          <Button
            size="bigger"
            type="primary"
            hasRoundedCorners
            isStretched
            isUppercase={false}
            hasShadow
            fontFamily={fontNormal}
            qaLabel="registration-submit-btn"
            isDisabled={isButtonDisabled}
            isLoading={false}
          >
            {buttonText}
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  );
};

RegistrationPromoCodeTemplate.defaultProps = {
  firstTitle: "Enter Promo Code",
  secondTitle: "Available promotions",
  buttonText: "Continue",
  isButtonDisabled: false,
  showApplyButton: false,
  showInputLoading: false,
  promoCodes: [],
  handleTCClick: noop,
  registrationAllPromosWithTC: false
};

export default RegistrationPromoCodeTemplate;
